/**
 * @callback Callback
 * */
/**
 * @typedef {object} OnOptions
 * @property {EventId} [id]
 * @property {boolean} [once]
 * @property {any} [context]
 * */
/**
 * @typedef {object} Config
 * @property {Callback} callback
 * @property {OnOptions['id']} [id]
 * @property {OnOptions['once']} once
 * */
/**
 * @typedef {string|number} EventId
 * */
/**
 * @typedef {object} EmitOptions
 * @property data
 * @property {boolean} [once]
 * */
/**
 * @typedef {string} EventTitle
 * */
/**
 * @typedef {Record<string, Config[]>} Registry
 * */
/**
 * @typedef {
*    'auth status update' |
*    'playlists change' |
*    'playlists change' |
 *   'current time change' |
 *   'playlists change' |
 *   'isPremium change' |
 *   'current track change' |
 *   'next' |
 *   'pause' |
 *   'previous' |
 *   'stop' |
 *   'repeat change'
 * } ProjectEvents
 * */
class EventEmitter {
    /** @type {Registry}*/
    _registry = {};
    /**
     * @param {ProjectEvents} eventTitle
     * @param {EmitOptions} [options]
     */
    emit(eventTitle, { data } = {}) {
        const cfgs = this._registry[eventTitle.toLowerCase()];
        if (!cfgs)
            return;
        const cfgsToRemove = [];
        cfgs.forEach(cfg => {
            cfg.callback(data);
            if (cfg.once)
                cfgsToRemove.push({ ...cfg });
        });
        cfgsToRemove.forEach(cfg => this.remove(eventTitle, cfg.id));
    }
    /**
     * Регист
     * @param {ProjectEvents} eventTitle  Название события
     * @param {Callback} callback
     * @param {OnOptions} [options]
     * */
    on(eventTitle, callback, options) {
        const title = eventTitle.toLowerCase();
        const payload = this.#formConfig(callback, options);
        if (!(title in this._registry)) {
            this._registry[title] = [payload];
        }
        else {
            this._registry[title].push(payload);
        }
        return { id: payload.id };
    }
    /**
     * @param {EventTitle} eventTitle
     * @param {EventId} id
     * */
    remove(eventTitle, id) {
        const title = eventTitle.toLowerCase();
        if (!(title in this._registry))
            throw Error('Указаное событие не зарегистрировано');
        const eventCfgs = this._registry[title];
        const index = eventCfgs.findIndex(el => el.id === id);
        if (index === -1)
            throw Error('События с указанным id не существует');
        eventCfgs.splice(index, 1);
        if (!eventCfgs.length) {
            delete this._registry[title];
        }
    }
    /**
     * @param {Callback} callback
     * @param {OnOptions} [options]
     * @return {Config}
     * */
    #formConfig(callback, { once = false } = {}) {
        return {
            callback,
            once,
            id: this.#getNewEventId(),
        };
    }
    #getNewEventId() {
        return new Date().getTime();
    }
}
export const eventEmitter = new EventEmitter();
